import React from 'react';
import { Heading, YStack } from 'tamagui';

import { StyledCard } from './styles';
import { BaseStationQRCode } from '../../../components/common';

export const QRCodeSection: React.FC = () => (
  <StyledCard width={335}>
    <Heading size="$6" lineHeight="$4">
      Scan in HG App to Link Base Station
    </Heading>
    <YStack alignItems="center" justifyContent="center">
      <BaseStationQRCode />
    </YStack>
  </StyledCard>
);
